import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import { useLayerManager } from '../hooks/useLayerManager';
import { LayerOptions, LayerRenderEvent } from './LayerManager';
import { Routes, useJourneyNavigation } from '../routes';

export interface LayerWidgetProps<T extends Routes> {
  renderLayer: (event: LayerRenderEvent<T>) => JSX.Element;
  options?: Omit<LayerOptions, 'render'>;
  route?: T;
}

export const LayerWidget = <T extends Routes = Routes.ADMIN_HOME>(props: LayerWidgetProps<T>) => {
  const layerManager = useLayerManager();
  const handler = useJourneyNavigation<T>(props.route as T);
  const ref = useRef(props.renderLayer);
  ref.current = props.renderLayer;

  const [handle] = useState(() => {
    return layerManager.showLayer({
      render: (event) =>
        ref.current({
          ...event,
          handler
        }),
      ...props.options
    });
  });

  useEffect(() => {
    return () => {
      handle?.dispose();
    };
  }, []);
  handle.update();
  return null;
};
